export function initSchedule() {
    document.addEventListener('click', async (e) => {
        const btn = e.target.closest('.js-schedule-more');
        if (!btn) return;

        const list = btn.closest('section')?.querySelector('.js-schedule-items');
        if (!list) return;

        const count    = parseInt(btn.dataset.count, 10);
        const total    = parseInt(btn.dataset.total, 10);
        const variant  = btn.dataset.variant || 'all';
        const eventId  = btn.dataset.eventId || '0';
        const loadMode = btn.dataset.loadMode || 'paginate';

        btn.disabled = true;

        if (loadMode === 'show_all') {
            const startPage = parseInt(btn.dataset.page, 10) + 1;
            try {
                for (let page = startPage; page <= total; page++) {
                    const body = new URLSearchParams({
                        action:   'schedule_load_more',
                        nonce:    ajax_object.schedule_nonce,
                        page:     page,
                        count:    count,
                        variant:  variant,
                        event_id: eventId,
                    });
                    const res  = await fetch(ajax_object.ajax_url, { method: 'POST', body });
                    const data = await res.json();
                    if (data.success && data.data.html) {
                        list.insertAdjacentHTML('beforeend', data.data.html);
                    }
                }
            } finally {
                btn.closest('.flex-performance-schedule__load-more')?.remove();
            }
            return;
        }

        let page = parseInt(btn.dataset.page, 10) + 1;

        const body = new URLSearchParams({
            action:   'schedule_load_more',
            nonce:    ajax_object.schedule_nonce,
            page:     page,
            count:    count,
            variant:  variant,
            event_id: eventId,
        });

        try {
            const res  = await fetch(ajax_object.ajax_url, { method: 'POST', body });
            const data = await res.json();

            if (data.success && data.data.html) {
                list.insertAdjacentHTML('beforeend', data.data.html);
                btn.dataset.page = page;
            }

            if (!data.success || !data.data.has_more) {
                btn.closest('.flex-performance-schedule__load-more')?.remove();
            } else {
                btn.disabled = false;
            }
        } catch {
            btn.disabled = false;
        }
    });
}
